import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';

export const initDayJs = () => {
	dayjs.extend(advancedFormat);
	dayjs.extend(timezone);
	dayjs.extend(utc);
	dayjs.extend(duration);
};

// 秒数转成 hh:mm:ss 或 mm:ss 的函数
export function formatSecondsToTime(seconds: number | string): string {
	const sec = Number(seconds);

	if (isNaN(sec) || sec < 0) return '00:00';

	const d = dayjs.duration(sec, 'seconds');
	const hrs = d.hours();
	const mins = d.minutes();
	const secs = d.seconds();

	const padded = (n: number) => String(n).padStart(2, '0');

	return hrs > 0
		? `${padded(hrs)}:${padded(mins)}:${padded(secs)}`
		: `${padded(mins)}:${padded(secs)}`;
}
